import actions from './actions';
import { produce } from 'immer';

import { convertAllProductsToColourArray } from 'utils/common'

const initState = {
  userObjects:[],

  selectedObjectId: 0,
  selectedObjectName: "Bedroom",

  isOpenConfirmModal: false,
  isOpenTemplateModal: false,
  isOpenCanvasItemConfigModal: false,
  isOpenCreatePaletModal: false,
  isOpenUpdatePaletModal: false,
  isOpenProjectModal: false,
  downloadPdf: false,
  isSelectedObject: false,
  isRendered: false ,

  confirmModalAction: {},
  toast: {
    isOpen: false,
    status: "",
    message: ""
  },

  imageBaseUrl:'',
  assetsPath: '',

  isLoggedIn: 0,
  customerId: 0,
  language: 'en',

  colours:[],
  userColours:{},
  coloursOnCanvas:[],
  priceData:[],
  updatedColour: {
    status: false,
    from: {},
    to: {},
    order: 0
  }
}

export default function reducer(state = initState, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case actions.IS_OPEN_CONFIRM_MODAL:
        draft.isOpenConfirmModal = !draft.isOpenConfirmModal;
        break;

      case actions.IS_OPEN_CREATE_PALET_MODAL:
        draft.isOpenCreatePaletModal = !draft.isOpenCreatePaletModal;
        break;

      case actions.IS_OPEN_UPDATE_PALET_MODAL:
        draft.isOpenUpdatePaletModal = !draft.isOpenUpdatePaletModal;
        break;
        

      case actions.IS_OPEN_TEMPLATE_MODAL:
        draft.isOpenTemplateModal = !draft.isOpenTemplateModal;
        break;

      case actions.IS_OPEN_CANVAS_ITEM_CONFIG_MODAL:
        draft.isOpenCanvasItemConfigModal = !draft.isOpenCanvasItemConfigModal;
        break;

      case actions.IS_OPEN_PROJECT_MODAL:
        draft.isOpenProjectModal = !draft.isOpenProjectModal;
      break;

      case actions.GET_COLOURS_REQUEST_SUCCESS: {
        // if(action.payload.products.length > 0) {
          draft.colours = convertAllProductsToColourArray(action.payload.products);
        //}
      }
      break;

      case actions.CREATE_USER_COLOURS: {
        draft.userColours = {
          ...draft.userColours,
          ...action.payload
        };
      }
      break;

      case actions.ADD_COLOUR_ON_CANVAS: {
        const selectedObject = draft.userObjects.find(obj => obj.objectId == draft.selectedObjectId);
        if(!draft.coloursOnCanvas.some(item => item.id_product_attribute === action.payload.id_product_attribute)) {
          draft.coloursOnCanvas.push(action.payload);
          if(selectedObject){
            selectedObject.object.coloursOnCanvas = [...draft.coloursOnCanvas];
          }
        }
        if(!draft.priceData.some(item => item.id_product_attribute === action.payload.id_product_attribute)) {
          draft.priceData.push(action.payload);
          if(selectedObject){
            selectedObject.object.priceData = [...draft.priceData];
          }
        }

      }
      break;

      case actions.CONFIRM_MODAL_ACTION_DEFINE: {
        draft.confirmModalAction = { ...action.payload };
      }
      break;

      case actions.REMOVE_COLOUR_0N_CANVAS: {
        const colours = [...draft.coloursOnCanvas].filter((item) => item.id_product_attribute !== action.payload);
        draft.coloursOnCanvas = [...colours];

        const priceData = [...draft.priceData].filter((item) => item.id_product_attribute !== action.payload);
        draft.priceData = [...priceData];

        const selectedObject = draft.userObjects.find(obj => obj.objectId == draft.selectedObjectId);
        if (selectedObject) {
          const _userObjects= draft.userObjects.map(obj => {
            if (obj.objectId === draft.selectedObjectId) {
              return {
                ...obj,
                object:{
                  coloursOnCanvas: colours,
                  priceData: priceData
                }
              }
            }
            return obj;
          });
          draft.userObjects = _userObjects;
        }

      }
      break;

      // case actions.REMOVE_COLOUR_0N_CANVAS: {
      //   draft.coloursOnCanvas = [...action.payload];
      // }
      // break;

      case actions.UPDATED_COLOUR_DEFINE: {
        draft.updatedColour = {
          status: false,
          order: action.payload.order,
          from: (draft.colours.filter((item) => item.id_product_attribute === action.payload.from))[0],
          to: (draft.colours.filter(item => item.id_product_attribute === action.payload.to))[0],
        }
      }
      break;

      case actions.UPDATE_TO: {
        const initOrder = state.coloursOnCanvas.findIndex((item) => item.id_product_attribute === draft.updatedColour.from.id_product_attribute);
        draft.updatedColour = {
          ...draft.updatedColour,
          to: action.payload,
          order: initOrder
        }
      }
      break;

      case actions.UPDATE_ORDER_OF_UPDATED_COLOUR: {
        draft.updatedColour = {
          ...draft.updatedColour,
          order: action.payload,
        }
      }
      break;

      case actions.UPDATE_STATUS_OF_UPDATED_COLOUR: {
        draft.updatedColour = {
          ...draft.updatedColour,
          status: action.payload
        }
      }
      break;

      case actions.UPDATE_USER_COLOURS: {
        let cloneUserColours = [ ...draft.coloursOnCanvas ].map(item => {
          if(item.id_product_attribute === draft.updatedColour.from.id_product_attribute) {
            return {
              ...item,
              ...draft.updatedColour.to
            }
          }
          return item;
        });

        let priceData = [ ...draft.priceData ].map(item => {
          if(item.id_product_attribute === draft.updatedColour.from.id_product_attribute) {
            return {
              ...item,
              ...draft.updatedColour.to,
            }
          }
          return item;
        });

        // change order - only swap if both indices are valid (skip for column layout positioning)
        const targetOrder = draft.updatedColour.order;
        const fromIndex = cloneUserColours.findIndex(item => item.id_product_attribute === draft.updatedColour.to.id_product_attribute);

        // Only swap if target order is 0 (background swap) and both indices exist
        // Column layouts (1, 2, 3) are handled visually by rectsOptions, not by array reordering
        if (targetOrder === 0 && fromIndex >= 0 && fromIndex !== 0 && cloneUserColours[0]) {
          const fromData = cloneUserColours[fromIndex];
          const toData = cloneUserColours[0];
          cloneUserColours[fromIndex] = toData;
          cloneUserColours[0] = fromData;
        }

        draft.coloursOnCanvas = [...cloneUserColours];
        draft.priceData = [...priceData];
      }
      break;

      case actions.UPDATE_VISIBILITY_ON_CANVAS: {
        let coloursOnCanvas = [...draft.coloursOnCanvas].map(item => {
          if(item.id_product_attribute === action.payload) {
            return {
              ...item,
              visible: !item.visible
            }
          }
          return item;
        });

        draft.coloursOnCanvas = [...coloursOnCanvas];
      }
      break;

      case actions.UPDATE_SIZE:{
        let priceData = [ ...draft.priceData ].map(item => {
            return {
              ...item,
              m2: action.payload.size[item.id_product_attribute],
              price: action.payload.price?.[item.id_product_attribute] ?? 0,
              quantity: action.payload.quantity?.[item.id_product_attribute] ?? 0,
              entirePrice: action.payload.entirePrice?.[item.id_product_attribute] ?? 0,
            }
        });

        draft.priceData = [...priceData];

        const selectedObject = draft.userObjects.find(obj => obj.objectId == draft.selectedObjectId);

        if(selectedObject){
          selectedObject.object.priceData = priceData;
        }
    
      }
      break;

      case actions.SAVE_USER_COLOURS: {
        draft.userColours = action.payload;
      }
      break;

      case actions.SET_USER_INFO: {
        draft.isLoggedIn = action.payload.isLoggedIn;
        draft.customerId = action.payload.customerId;
      }
      break;

      case actions.INIT_USER_DATA: {
        // if(draft.isLoggedIn === 1) {
          Object.assign(draft, action.payload);
        // }
      }
      break;

      case actions.GET_OBJECTS_REQUEST_SUCCESS: {
        if(action.payload.length) {
          draft.userObjects = [...action.payload];
          draft.selectedObjectId = action.payload[0].objectId;
          draft.selectedObjectName = action.payload[0].objectName;

          draft.isSelectedObject = true;
          draft.selectedObjectId = action.payload[0].objectId;
          draft.coloursOnCanvas = action.payload[0].object.coloursOnCanvas || [];
          draft.priceData = action.payload[0].object.priceData || [];
          draft.selectedObjectId = action.payload[0].objectId;
          draft.selectedObjectName = action.payload[0].objectName;
          // Object.assign(draft, JSON.parse(action.payload.length[0]));

          // coloursOnCanvas:[],
          // priceData:[],
          // updatedColour: {
          //   status: false, 
          //   from: {},
          //   to: {},
          //   order: 0
          // }

          // const selectedRoom = _objects.find(obj => obj.objectId.toString() === selectedId);
        }
      }
      break;

      case actions.SET_LANGUAGE: {
        draft.language = action.payload;
      }
      break;

      case actions.SET_ASSETS_PATH: {
        draft.assetsPath = action.payload;
      }
      break;

      case actions.OPEN_TOAST: {
        if(action.payload) {
          draft.toast = {
            isOpen: true,
            status: action.payload.status,
            message: action.payload.message
          };
        }
      }
      break;

      case actions.CLOSE_TOAST: {
        draft.toast = {
          isOpen: false,
          status: "",
          message: ""
        };
      }
      break;

      case actions.SELECT_OBJECT: {
        const selectedObject = [...draft.userObjects].find(obj => obj.objectId == action.payload);

        if (selectedObject) {
          // draft.selectedObjectId = selectedObject.objectId;
          // draft.selectedObjectName = selectedObject.objectName;
          draft.isSelectedObject = true;
          draft.selectedObjectId = action.payload;
          draft.coloursOnCanvas = selectedObject.object.coloursOnCanvas || [];
          draft.priceData = selectedObject.object.priceData || [];
          draft.selectedObjectName = selectedObject.objectName;
          draft.isRendered = true;
          // draft.userColours = selectedObject.userColours;

          // For debug:
        }
      }
      break;

      case actions.IS_SELECTED_OBJECT: {
        draft.isSelectedObject = false;
      }
      break;

      case actions.IS_RENDERED: {
        draft.isRendered = draft.isRendered + 1;
      }
      break;

      case actions.CREAT_PROJECT_REQUEST_SUCCESS: {
        const newObject =   {
          "objectId": action.payload.objectID,
          "objectName": action.payload.objectName,
          "object": {
            "objectName": "Bedroom",
            "userColours": [],
            "priceData": action.payload.priceData,
            "coloursOnCanvas": action.payload.coloursOnCanvas
          }
        };

        draft.userObjects = [
          ...draft.userObjects,
          newObject
        ]
      }
      break;

      case actions.DELET_PROJECT_REQUEST_SUCCESS: {
        const deletedId = action.payload.payload.objectID;
      
        const _deletedUserObjects = draft.userObjects.filter(obj => obj.objectId != deletedId);
      
        draft.userObjects = _deletedUserObjects;
      
        if (_deletedUserObjects.length > 0) {
          const firstObj = _deletedUserObjects[0];
          draft.isSelectedObject = true;
          draft.selectedObjectId = firstObj.objectId;
          draft.coloursOnCanvas = firstObj.object.coloursOnCanvas || [];
          draft.priceData = firstObj.object.priceData || [];
          draft.selectedObjectName = firstObj.objectName;
          draft.isRendered = true;
        } else {
          draft.isSelectedObject = false;
          draft.selectedObjectId = -1;
          draft.coloursOnCanvas = [];
          draft.priceData = [];
          draft.selectedObjectName = '';
          draft.isRendered = true;
        }
        break;
      }

      default:
        break;
    }
  });
}